import React, {useEffect} from 'react';
import { IntlProvider, createIntl} from 'react-intl';

import { translationMessages } from './i18n';

export interface Props {
  messages: { [locale: string]: { [id: string]: string } };
  children?: React.ReactNode;
}

export var _intlProvider = undefined;
export const getIntl = ()=> _intlProvider;

export default function LanguageProvider({locale = 'ko', children}: Props) {
//   const { locale } = useSelector(stateSelector);
  useEffect(()=>{
    _intlProvider = createIntl({ locale, messages:translationMessages[locale] });
  },[locale])

  return (
    <IntlProvider locale={locale||'ko'} messages={translationMessages[locale||'ko']}
      onError={(err) => {
        if (err.code === "MISSING_TRANSLATION") {
          return;
        }
        throw err;
      }}
    >
      {React.Children.only(children)}
    </IntlProvider>
  );
}
